import React from "react";
//import TermsHero from "./components/TermsSaveHungerHero";
//import TextSection from "./components/TextSaveHungerSection";
import TermsSaveHungerGetIntouch from "./components/TermsSaveHungerGetIntouch";
import TextSaveHungerSection from "./components/TextSaveHungerSection";
import TermsSaveHungerHero from "./components/TermsSaveHungerHero";
//import TermsGetIntouch from "./components/TermsSaveHungerGetIntouch";

type Props = {};

const TermsSaveHunge = (props: Props) => {
  return (
    <div>
      <TermsSaveHungerHero />
      <TextSaveHungerSection />
      <TermsSaveHungerGetIntouch />
    </div>
  );
};

export default TermsSaveHunge;
